// API interfaces for the system
import { http } from '@/utils/request.js'

// Login interface
/**
 * @typedef {Object} LoginRequest
 * @property {string} userAccount - 账号或手机号
 * @property {string} userPassword - 密码
 */

/**
 * @typedef {Object} LoginResponse
 * @property {boolean} success
 * @property {string} [message]
 * @property {string} [token]
 */

// Statistics interfaces
/**
 * @typedef {Object} DataMoney
 * @property {number} totalAmount - 购买套餐总金额
 * @property {number} monthlyAmount - 本月购买总金额
 * @property {number} dailyAmount - 当天购买总金额
 */

/**
 * @typedef {Object} DevStatistics
 * @property {number} total - 设备总数量
 * @property {number} online - 在线总数量
 * @property {number} make - 设备利用率0-100%
 */

/**
 * @typedef {Object} UserStatistics
 * @property {number} total - 用户总数
 * @property {number} active - 活跃用户数，拥有生效中套餐的用户
 * @property {number} increase - 当天新增用户数
 */

/**
 * @typedef {Object} ElectricalChangeRecord
 * @property {string} id - 换电记录id
 * @property {number} orderType - 订单类型;0人工换电1柜端换电2扫码换电
 * @property {string} outNumber - 出仓门号
 * @property {string} intoNumber - 进仓门号
 * @property {string} outPack - 出仓电池
 * @property {string} intoPack - 进仓电池
 * @property {string} outPackSoc - 出仓电池soc
 * @property {string} intoPackSoc - 进仓电池soc
 * @property {string} cabId - 换电柜编号
 * @property {string} clientId - 客户编号
 * @property {number} beforeConsumption - 消耗之前余额
 * @property {number} consumption - 消耗
 * @property {number} afterConsumption - 消耗之后余额
 * @property {string} orderTime - 订单时间
 * @property {number} operation - 操作状态码
 * @property {number} state - 状态;0失败1成功
 * @property {string} storeId - 门店id
 * @property {string} storeName - 门店名
 * @property {string} phone - 用户手机号
 * @property {string} realName - 用户真实名称，实名认证名称
 * @property {string} nickName - 用户昵称
 */

/**
 * @typedef {Object} ChangeElectricityStatistics
 * @property {string} day - 日期 2025-06-04
 * @property {number} count - 对应日期的换电次数，失败也算在内
 */

/**
 * @typedef {Object} DevType
 * @property {string} type - 设备类型名
 * @property {number} count - 对应类型的统计设备数量
 */

/**
 * @typedef {Object} CityCount
 * @property {string} city - 城市
 * @property {number} storeCount - 对应城市的门店数量
 * @property {number} cabinetCount - 对应城市的电柜数量
 * @property {number} packCount - 对应城市的电池数量
 * @property {number} vehicleCount - 对应城市的车辆数量
 */

/**
 * @typedef {Object} CityResource
 * @property {number} storeTotal - 门店总数
 * @property {number} cabinetTotal - 电柜总数
 * @property {number} packTotal - 电池总数
 * @property {number} vehicleTotal - 车辆总数
 * @property {CityCount[]} cityCount - 城市分布设备总数
 */

/**
 * @typedef {Object} StatisticsResponse
 * @property {DataMoney} dataMoney - 购买金额统计
 * @property {DevStatistics} packStatistics - 电池数量统计
 * @property {DevStatistics} bssStatistics - 电柜数量统计
 * @property {UserStatistics} userStatistics - 用户数量统计
 * @property {ElectricalChangeRecord[]} electricalChangeRecords - 最新的30条换电记录
 * @property {ChangeElectricityStatistics[]} changeElectricityStatistics - 近一个月内每天的换电次数统计
 * @property {DevType[]} packTypes - 电池型号分布数量
 * @property {DevType[]} bssTypes - 电柜型号分布数量
 * @property {CityResource} cityResource - 地图资源详情
 */

// API functions
/**
 * 登录接口
 * @param {LoginRequest} data - 登录请求参数
 * @returns {Promise<LoginResponse>}
 */
export const login = async (data) => {
  return http.post('/system/data/login', data);
};

/**
 * 获取统计数据接口
 * @returns {Promise<StatisticsResponse>}
 */
export const getStatistics = async () => {
  return http.get('/system/data/statistics');
}; 